const constants = {
  API_TIMEOUT: 240000,
  DEFAULT_CONTENT_TYPE: "application/json; charset=utf-8",
  MULTIPART_CONTENT_TYPE: "multipart/form-data",
  SERVICES_API_BASE_URL: process.env.VITE_SERVICES_API_BASE_URL,
  SERVICES_API_DIRECT_URL: process.env.VITE_SERVICES_API_DIRECT_URL,
  DOT_NET_API_BASE_URL: process.env.VITE_DOT_NET_API_BASE_URL,
  IAM_BASE_URL: process.env.VITE_IAM_BASE_URL,
  GLOBAL_SEARCH_BASE_URL: process.env.VITE_GLOBAL_SEARCH_BASE_URL,
  userId: "68224a45-8d82-11ec-b34c-42010a498c04",
  SERVICES_API_ICARE: process.env.VITE_ICARE_URL,
  appId: "629f635b5ac837fa4164b967",
  TOKEN_RECALL_LIMIT: 5,
  COMMON_SERVICES_BASE_URL: process.env.VITE_COMMON_SERVICES_BASE_URL,
  FIREBASE_CONFIG: process.env.VITE_FIREBASE_CONFIG
};

export default constants;
